import { ArnHttpService } from '../http/ArnHttpService';
import { ArnValidDataConfig } from '@arianee/arn-types';
import { ArnAuthService } from '../auth';
import { ArnDataService } from './ArnDataService';

export class DefaultArnDataService implements ArnDataService {
  constructor(
    readonly config: ArnValidDataConfig,
    protected http: ArnHttpService,
    protected auth: ArnAuthService
  ) {}

  async get<T = any>(path: string): Promise<T> {
    return this.http.fetchAuthorizedJson<T>(this.auth, this.config.url + path);
  }
}
